'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _charities = require('../../api/charities');

var _inputSelect = require('constructicon/input-select');

var _inputSelect2 = _interopRequireDefault(_inputSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CharitySelect = function (_Component) {
  _inherits(CharitySelect, _Component);

  function CharitySelect(props) {
    _classCallCheck(this, CharitySelect);

    var _this = _possibleConstructorReturn(this, (CharitySelect.__proto__ || Object.getPrototypeOf(CharitySelect)).call(this, props));

    _this.state = {
      results: [],
      status: null
    };
    return _this;
  }

  _createClass(CharitySelect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var campaign = this.props.campaign;


      Promise.resolve().then(function () {
        return _this2.setState({ status: 'fetching' });
      }).then(function () {
        return (0, _charities.fetchCharities)({ campaign: campaign });
      }).then(function (results) {
        return results.map(_this2.deserializeCharity);
      }).then(function (results) {
        return _this2.setState({ results: results, status: 'fetched' });
      }).catch(function (error) {
        _this2.setState({ status: 'failed' });
        return Promise.reject(error);
      });
    }
  }, {
    key: 'deserializeCharity',
    value: function deserializeCharity(charity) {
      return {
        label: charity.name,
        value: charity.id
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var inputProps = this.props.inputProps;
      var results = this.state.results;


      return _react2.default.createElement(_inputSelect2.default, _extends({
        options: [{ label: 'Please select', value: '' }].concat(_toConsumableArray(results))
      }, inputProps));
    }
  }]);

  return CharitySelect;
}(_react.Component);

CharitySelect.propTypes = {
  /**
   * Only show charities in this campaign
   */
  campaign: _propTypes2.default.string,

  /**
   * The props to be passed to the input select component
   */
  inputProps: _propTypes2.default.object
};

exports.default = CharitySelect;


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/components/charity-select/index.js
// module id = 1430
// module chunks = 0